import { useId } from 'react';
import { Icon } from '@platform/ui';
import type { ICollapsibleGroupProps } from './ICollapsibleGroupProps';

/**
 * Розгортна група лівого меню (UIUX layout/left-menu): кнопка-заголовок 12px 700 у верхньому регістрі з лінією зверху й шевроном праворуч
 * (згорнута — шеврон повернуто вбік), aria-expanded/aria-controls; пункти рендеряться лише в розгорнутому стані.
 */
export function CollapsibleGroup({ title, open, onToggle, children }: ICollapsibleGroupProps) {
  const id = useId();
  return (
    <>
      <button type="button" className="mnav__group" aria-expanded={open} aria-controls={open ? id : undefined} onClick={onToggle}>
        <span className="mnav__group-title">{title}</span>
        <Icon name="chevron-down" size={12} strokeWidth={2.4} className="mnav__chevron" />
      </button>
      {open && <div id={id} className="mnav__items">{children}</div>}
    </>
  );
}
